import { render } from "./minFoodDisplay.vue?vue&type=template&id=db9761e0"
import script from "./minFoodDisplay.vue?vue&type=script&lang=js"
export * from "./minFoodDisplay.vue?vue&type=script&lang=js"

import "./minFoodDisplay.vue?vue&type=style&index=0&id=db9761e0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__